import { TmApiPreconditionRequiredError } from '@/core/error/transport/tmApiPreconditionRequiredError'

export class TmApiStripeInvalidBillingDetailsError extends TmApiPreconditionRequiredError {
  public name = 'TmApiStripeInvalidBillingDetailsError'
}
